import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, OnInit } from '@angular/core';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { ConfirmSharedNoteComponent } from '../confirm-shared-note/confirm-shared-note.component';
import { AlertifyService, Note, Project, Tags } from 'core';
import { NotesService } from 'projects/core/src/services/note.service';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-vendor-note-popup',
  templateUrl: './vendor-note-popup.component.html',
  styleUrls: ['./vendor-note-popup.component.scss']
})
export class VendorNotePopupComponent implements OnInit {

  subject: string = '';
  title: string = '';
  addToAllVendors: boolean = false;
  openModalRef: BsModalRef;
  hidden: boolean = false;

  editorConfig = {
    startupFocus: true,
    language: 'en',
    placeholder: "Type body and click save",
    toolbar: {
      items: [
        'bold',
        'italic',
        'link',
        'bulletedList',
        'numberedList'
      ],
      
    }
  };

  newNote: Note = {
    message: '',
  } as Note;

  @Input() project = {} as Project;
  @Input() partnerId: string;
  @Input() partnerName: string;


  constructor(
    public bsModalRef: BsModalRef,
    public modalService: BsModalService,
    private noteService: NotesService,
    private alertify: AlertifyService,
  ) { }

  ngOnInit() {
  }

  closeModal() {
    this.bsModalRef.hide();
  }
  save() {
    if (this.newNote.message.trim() === '') {
      this.alertify.error('Please write a note.');
      return;
    }
    // Here you would typically save the note to your backend or service
    if(!this.addToAllVendors) {
      this.saveNote(this.partnerId);
    }
    else {

      const option : ModalOptions = {
        id: '2',
        class: 'd-flex align-items-center h-100 m-auto',
        initialState: {
          confirmSave: () => {
            this.project.projectSegments[0].projectSurveyPartners.forEach(partner => {
              if(partner.isDeleted == false) {
                this.saveNote(partner.partnerId);
              }
            });
          }
        }
      };
      this.openModalRef = this.modalService.show(ConfirmSharedNoteComponent, option);
    }
    
  }


  saveNote(partnerId: string) {
    this.newNote.id =  uuidv4();
    this.newNote.projectId = this.project.id;
    this.newNote.partnerId = partnerId;
    this.newNote.subject = this.subject;
    this.newNote.title = this.title;
    const regexp = /\B\#\w\w+\b/g;
    const result = this.newNote.message.match(regexp);

    const tags: Tags[] = [];

    if (result != null) {
      for (let i = 0; i < result.length; i++) {
        const newTag = {} as Tags;
        newTag.tag = result[i];
        newTag.tag = newTag.tag.replace(/#/g, '');
        newTag.id =  uuidv4();
        tags.push(newTag);
      }
    }

    this.newNote.tags = tags;
    this.noteService.addNote(this.newNote).subscribe(() => {
      this.alertify.success('Note added successfully');
      this.bsModalRef.hide();
      this.newNote = {message: ''} as Note;
    }, error => console.error(error));
  }

  toggleVisibility(state: boolean) {
    this.hidden = !state;
  }

  cancel() {
    this.newNote = {message: ''} as Note;
    this.bsModalRef.hide();
  }

  wysiwygUpdate(event) { 
    this.newNote.message = event;
  }
}
